import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function Tbody(props: Props) {
  const { children, className, ...rest } = props;
  return (
    <tbody className={className} {...rest}>
      {children}
    </tbody>
  );
}
